import { FormFieldType, type LookupConfig } from '../types/trigger';
import { FILTERS_GROUP_ID } from '../constants/workflow-client';
import { Comparison } from 'vince-core/types/common.ts';

// TODO remove browse
export const FormFieldsComponents = {
    [FormFieldType.TEXT]: defineAsyncComponent(() => import('../components/workflow-components/trigger/fields/Text.vue')),
    [FormFieldType.DATE]: defineAsyncComponent(() => import('../components/workflow-components/trigger/fields/Date.vue')),
    [FormFieldType.BROWSE]: defineAsyncComponent(() => import('../components/workflow-components/trigger/fields/Text.vue')),
    [FormFieldType.TAG]: defineAsyncComponent(() => import('../components/workflow-components/trigger/fields/Tag.vue'))
} as Record<FormFieldType, Component>;

// TODO remove browse
export const SUPPORTED_FIELD_TYPES = Object.values(FormFieldType).filter(it => it !== FormFieldType.BROWSE);

export const emptyLookup = () => {
    return <LookupConfig>{ lookupName: '', workflowName: '', workflowId: '', inputMap: {}, outputMap: {} };
};

export const EXCLUDABLE_FORM_GROUPS = [FILTERS_GROUP_ID];

export const VALUE_NOT_REQUIRED = [Comparison.isBlank, Comparison.isNotBlank];

export const MANDATORY_FIELD_SUFFIX = ' (*)';

export const IGNORE_FILTER_VALUE = 'IGNORE_FILTER';

export enum FilterMode {
    FILTER = 'FILTER',
    EXPRESSION = 'EXPRESSION'
}

export const EXPRESSION = 'expression';

export const TRIGGER_STEP_PREFIX = 'trigger_';
